import {
  I_ACCESS_TOKEN_PARAMS,
  I_COMMON_DELETE_PARAMS,
  I_COMMON_GET_ITEM_PARAMS,
  I_COMMON_CREATE_PARAMS,
  I_COMMON_PUT_PARAMS,
  I_COMMON_IMPORT_PARAMS,
  _customFetch,
  getFetchGETOptions,
  getFetchDELETEOptions,
} from './_base';
import LoggerService,{formatTrace} from '../../LoggerService';
import {I_CHARGE_ACTIVITY} from '../interfaces/I_CHARGES';
import APP_CONFIG from 'config';

// ---------------------------------
// --- CHARGES
// ---------------------------------

const ENDPOINT_CHARGES = '/charges';

const logger = LoggerService.getInstance();

interface I_GET_PARAMS extends I_ACCESS_TOKEN_PARAMS {
  from_date: string;
  to_date: string;
  activity_types: string;
  directions_ops: string;  // direction de la charge
  hubs_ops: string;  // pole de direction de la charge
  directions_hr: string;  // direction de l'activité de la charge
  hubs_hr: string;  // pole de direction de l'activité de la charge
  collaborators: string;
  skills: string;
  functions: string;
  billing_customers: string;
  audited_customers: string;
  referentials: string;
  referential_types: string;
  of_number: string;
}
interface I_CHARGE_FIELDS {
  /** id du model si la charge a été créée à partir d'un model de charge, undefined/null sinon */
  id_model?: number;
  //** nom de la charge */
  name: string;
  /** id du client / organisme */
  audited_customer_id: number;
  /** id du referentiel client (agrement d'organisme) */
  referential_customer_id: number;
  /** date de debut */
  from_date: string;
  /** date de fin */
  to_date: string;
  /** direction OPS de la charge */
  direction: string;
  /** pole de direction OPS de la charge */
  hub: string;
  /** volume horaire de la charge */
  hourly_volume: number;
  /** description de la charge (opt.) */
  description?: string;
  /** id du type d'activité de la charge (opt.) */
  activity_type_id?: number;
  /** id du donneur d'ordre (opt.) */
  billing_customer_id?: number;
  /** Numero d'OF (liaison charge - facturation) (opt.) */
  of_number?: string;
  /** numero du ticket JIRA associé */
  nb_tickets_jira?: number;
  /** liste des activités du modele de charge (peut etre vide) */
  activities: I_CHARGE_ACTIVITY[];
}
interface I_CHARGE_POST_PARAMS extends I_COMMON_CREATE_PARAMS, I_CHARGE_FIELDS {}
interface I_CHARGE_PUT_PARAMS extends I_COMMON_PUT_PARAMS, I_CHARGE_FIELDS {}

interface I_EXPORT_PARAMS extends I_ACCESS_TOKEN_PARAMS {
  from_date: string;
  to_date: string;
  activity_types: string;
  directions_ops: string;  // direction de la charge
  hubs_ops: string;  // pole de direction de la charge
  directions_hr: string;  // direction de l'activité de la charge
  hubs_hr: string;  // pole de direction de l'activité de la charge
  collaborators: string;
  skills: string;
  functions: string;
  billing_customers: string;
  audited_customers: string;
  referentials: string;
  referential_types: string;
  of_number: string;
  file_type: string;  // csv ou  xls
  file_format: string;  // encoding utf-8
}



/**
 * Requete le endpoint charges
 * Récupère la liste des charges
 * @param param0
 */
const get = async ({
  accessToken,page,
  from_date,to_date,activity_types,
  directions_ops,hubs_ops,directions_hr,hubs_hr,
  collaborators,skills,functions,billing_customers,
  audited_customers,
  referentials,
  referential_types,
  of_number,
}:I_GET_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - charges - get...'));
  const options = getFetchGETOptions({accessToken});
  const paramPage = `${page ? '&page=' + page : ''}`;
  const paramFromDate = `from_date=${from_date}`;
  const paramToDate = `to_date=${to_date}`;
  const paramActivityTypes = activity_types ? `activity_types=${activity_types}` : '';
  const paramDirectionsOps = directions_ops ? `directions_ops=${directions_ops}` : '';
  const paramHubsOps = hubs_ops ? `hubs_ops=${hubs_ops}` : '';
  const paramDirectionsHr = directions_hr ? `directions_hr=${directions_hr}` : '';
  const paramHubsHr = hubs_hr ? `hubs_hr=${hubs_hr}` : '';
  const paramCollaborators = collaborators ? `collaborators=${collaborators}` : '';
  const paramSkills = skills ? `skills=${skills}` : '';
  const paramFunctions = functions ? `functions=${functions}` : '';
  const paramBillingCustomers = billing_customers ? `billing_customers=${billing_customers}` : '';
  const paramAuditedCustomers = audited_customers ? `audited_customers=${audited_customers}` : '';
  const paramReferentials = referentials ? `referential_customers=${referentials}` : '';
  const paramReferentialTypes = referential_types ? `referential_types=${referential_types}` : '';
  const paramOFNumber = of_number ? `of_number=${of_number}` : '';
  const paramsAll = [
    paramFromDate,
    paramToDate,
    paramActivityTypes,
    paramDirectionsOps,
    paramHubsOps,
    paramDirectionsHr,
    paramHubsHr,
    paramCollaborators,
    paramSkills,
    paramFunctions,
    paramBillingCustomers,
    paramAuditedCustomers,
    paramReferentials,
    paramReferentialTypes,
    paramOFNumber,
  ].join('&');
  const URL = `${ENDPOINT_CHARGES}${APP_CONFIG.ENDPOINT_SUFFIX}?${paramsAll}${paramPage}`;
  return _customFetch(URL,options);
};


/**
 * Requete le endpoint charge
 * Récupère le charge
 * @param param0
 * @returns
 */
const getItem = async ({accessToken,id}:I_COMMON_GET_ITEM_PARAMS) => {
  logger.trace(...formatTrace('ApiEndpoints - charges - getItem...'));
  const options = getFetchGETOptions({accessToken});
  const URL = `${ENDPOINT_CHARGES}/${id}${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,options);
};

/**
 * Requete le endpoint charge POST
 * Ajoute un charge
 * @param param0
 * @returns
 */
export const post = async (args:I_CHARGE_POST_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - charges - post...'));
  const {
    accessToken,
    name,description,of_number,hourly_volume,
    direction,hub,
    from_date,to_date,
    audited_customer_id,
    referential_customer_id,
    billing_customer_id,
    activity_type_id,
    nb_tickets_jira,
    id_model,
    activities,
  } = args;
  const params = {
    method: 'POST',
    headers: {
      'X-API-KEY': APP_CONFIG.API_KEY,
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    },
    body: JSON.stringify({
      model: false,
      id_model,
      name: encodeURIComponent(name.trim()),
      description: encodeURIComponent(description?.trim() || ''), // opt
      of_number: of_number ? encodeURIComponent(of_number.trim()) : undefined, // opt
      hourly_volume,
      direction: direction ? encodeURIComponent(direction) : undefined,
      hub: hub ? encodeURIComponent(hub) : undefined,
      from_date,
      to_date,
      audited_customer_id,
      referential_customer_id,
      billing_customer_id,  // opt
      activity_type_id, // opt
      nb_tickets_jira,  // opt
      activities, // opt
    })
  };
  const URL = ENDPOINT_CHARGES + APP_CONFIG.ENDPOINT_SUFFIX;
  return _customFetch(URL,params);
};

/**
 * Requete le endpoint charge DELETE
 * Supprime un charge
 * @param param0
 * @returns
 */
const remove = async ({accessToken,id}:I_COMMON_DELETE_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - charges - remove...'));
  const options = getFetchDELETEOptions({accessToken});
  const URL = `${ENDPOINT_CHARGES}/${id}${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,options);
};

/**
 * Requete le endpoint charge PUT
 * Met à jour un charge
 * @param param0
 * @returns
 */
const put = async (args:I_CHARGE_PUT_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - charges - put...'));
  const {
    accessToken,
    id,
    name,description,of_number,hourly_volume,
    direction,hub,
    from_date,to_date,
    audited_customer_id,
    referential_customer_id,
    billing_customer_id,
    activity_type_id,
    nb_tickets_jira,
    id_model,
    activities,
  } = args;
  const params = {
    method: 'PUT',
    headers: {
      'X-API-KEY': APP_CONFIG.API_KEY,
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    },
    body: JSON.stringify({
      model: false,
      id_model,
      name: encodeURIComponent(name.trim()),
      description: encodeURIComponent(description?.trim() || ''), // opt
      of_number: of_number ? encodeURIComponent(of_number.trim()) : undefined, // opt
      hourly_volume,
      direction: direction ? encodeURIComponent(direction) : undefined,
      hub: hub ? encodeURIComponent(hub) : undefined,
      from_date,
      to_date,
      audited_customer_id,
      referential_customer_id,
      billing_customer_id,  // opt
      activity_type_id, // opt
      nb_tickets_jira,  // opt
      activities, // opt
    })
  };
  const URL = `${ENDPOINT_CHARGES}/${id}${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,params);
};

/**
 * Requete le endpoint POST file
 * Import des charges
 * @param param0
 * @returns
 */
const importList = async ({accessToken,file}:I_COMMON_IMPORT_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - charges - importList...'));
  const formData  = new FormData();
  formData.append("file",file,file.name);
  const params = {
    method: 'POST',
    headers: {
      'X-API-KEY': APP_CONFIG.API_KEY,
      // 'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    },
    body: formData,
  };
  const URL = `${ENDPOINT_CHARGES}/import${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,params,APP_CONFIG.IMPORT_EXPORT_TIMEOUT);
};

const exportList = async ({
  accessToken,
  from_date,to_date,activity_types,
  directions_ops,hubs_ops,directions_hr,hubs_hr,
  collaborators,skills,functions,billing_customers,
  audited_customers,
  referentials,
  referential_types,
  of_number,
  file_type,
  file_format,
}:I_EXPORT_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - charges - exportList...'));
  const options = getFetchGETOptions({accessToken});
  const paramFromDate = `from_date=${from_date}`;
  const paramToDate = `to_date=${to_date}`;
  const paramActivityTypes = activity_types ? `activity_types=${activity_types}` : '';
  const paramDirectionsOps = directions_ops ? `directions_ops=${directions_ops}` : '';
  const paramHubsOps = hubs_ops ? `hubs_ops=${hubs_ops}` : '';
  const paramDirectionsHr = directions_hr ? `directions_hr=${directions_hr}` : '';
  const paramHubsHr = hubs_hr ? `hubs_hr=${hubs_hr}` : '';
  const paramCollaborators = collaborators ? `collaborators=${collaborators}` : '';
  const paramSkills = skills ? `skills=${skills}` : '';
  const paramFunctions = functions ? `functions=${functions}` : '';
  const paramBillingCustomers = billing_customers ? `billing_customers=${billing_customers}` : '';
  const paramAuditedCustomers = audited_customers ? `audited_customers=${audited_customers}` : '';
  const paramReferentials = referentials ? `referential_customers=${referentials}` : '';
  const paramReferentialTypes = referential_types ? `referential_types=${referential_types}` : '';
  const paramOFNumber = of_number ? `of_number=${of_number}` : '';
  const paramFileType = file_type ? `file_type=${file_type}` : '';
  const paramFileFormat = file_format ? `file_format=${file_format}` : '';
  const paramsAll = [
    paramFromDate,
    paramToDate,
    paramActivityTypes,
    paramDirectionsOps,
    paramHubsOps,
    paramDirectionsHr,
    paramHubsHr,
    paramCollaborators,
    paramSkills,
    paramFunctions,
    paramBillingCustomers,
    paramAuditedCustomers,
    paramReferentials,
    paramReferentialTypes,
    paramOFNumber,
    paramFileType,
    paramFileFormat,
  ].join('&');
  const URL = `${ENDPOINT_CHARGES}/export${APP_CONFIG.ENDPOINT_SUFFIX}?${paramsAll}`;
  return _customFetch(URL,options,APP_CONFIG.IMPORT_EXPORT_TIMEOUT);
};

const chargesEndpoints = {
  get,
  post,
  remove,
  put,
  getItem,
  importList,
  exportList,
};

export default chargesEndpoints;
